
class SearchTrigger extends HTMLElement{
    
    constructor(){
        super();

        const self = this;

        this.search = document.querySelector('[data-search-form]');
        this.escapeArea = document.querySelector('[data-search-escape-area]');

        this.addEventListener('click', this.toggleSearch.bind(this));
        this.escapeArea.addEventListener('click', this.close.bind(this));

        document.addEventListener('keyup', function (e) {
            if (e.key === "Escape") {
                self.close();
            }
        });
    }

    open() {

        event.preventDefault();

        document.querySelector('body').classList.add('overflow-hidden');

        this.search.classList.toggle('is--active');


        // this.openIcon.classList.remove('block');
        // this.openIcon.classList.add('hidden');

        // this.closeIcon.classList.add('block');
        // this.closeIcon.classList.remove('hidden');
    }

    close() {

        event.preventDefault();
        
        document.querySelector('body').classList.remove('overflow-hidden');

        this.search.classList.remove('is--active');
        // this.search.classList.add('is--active');

        // this.openIcon.classList.add('block');
        // this.openIcon.classList.remove('hidden');

        // this.closeIcon.classList.remove('block');
        // this.closeIcon.classList.add('hidden');
    }

    toggleSearch() {

        console.log('toggleSearch');

        this.search.classList.toggle('is--active');

        // this.openIcon.classList.add('block');
        // this.openIcon.classList.remove('hidden');

        // this.closeIcon.classList.remove('block');
        // this.closeIcon.classList.add('hidden');

        // Target is open
        // if( this.search.classList.contains('is--active') ){
        //     // this.close();
        // }else{
        //     // this.open();
        // }
    }
}

customElements.define('search-trigger', SearchTrigger);